import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const pct = (p) => (p == null ? ", " : `${Math.round(p * 100)}%`);

export const RescoreTable = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/forecasts/rescore`).then((r) => alive && setData(r.data)).catch(() => alive && setData({ rows: [] }));
    return () => { alive = false; };
  }, []);
  if (!data || !data.rows?.length) return null;
  const s = data.summary || {};
  return (
    <div className="whip-surface rounded-xl border border-white/10 p-5 mb-6" data-testid="rescore-table-card">
      <div className="flex items-baseline justify-between flex-wrap gap-2 mb-1">
        <div>
          <h2 className="text-[11px] font-mono font-bold uppercase tracking-[0.2em] text-white/60 flex items-center gap-2">
            <RefreshCw className="w-3.5 h-3.5 text-orange-400" /> Misses Re-scored With The Current Model
          </h2>
          <p className="text-xs text-white/45">
            Each missed vote re-run as of the evening before, using only what was public then: actions to date and that week's published floor schedule. The original record is unchanged.
          </p>
        </div>
        <div className="flex gap-2 flex-wrap" data-testid="rescore-summary">
          <span className="whip-pill !py-0.5 !px-2 !text-[9px]">Old: {s.oldHits}/{s.n} called right · Brier {s.oldBrier}</span>
          <span className="whip-pill !py-0.5 !px-2 !text-[9px] !text-emerald-300 !border-emerald-500/40 !bg-emerald-500/10">Re-scored: {s.newHits}/{s.n} called right · Brier {s.newBrier}</span>
        </div>
      </div>
      <div className="overflow-x-auto mt-3">
        <table className="w-full text-xs" data-testid="rescore-table">
          <thead>
            <tr className="text-white/45 font-mono uppercase tracking-wider text-[10px]">
              <th className="text-left py-2 pr-3">Bill</th>
              <th className="text-left py-2 pr-3">Vote</th>
              <th className="text-right py-2 pr-3">Old</th>
              <th className="text-right py-2 pr-3">Re-scored</th>
              <th className="text-left py-2 pr-3">Signal Used</th>
              <th className="text-right py-2">Result</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={`${r.billId}-${r.voteDate}`} className="border-t border-white/5" data-testid={`rescore-row-${r.billId}`}>
                <td className="py-2 pr-3">
                  <Link to={`/bill/${r.billId}`} className="text-orange-300 font-semibold hover:underline">{r.billNumber}</Link>
                  <div className="text-white/40 truncate max-w-[260px]">{r.title}</div>
                </td>
                <td className="py-2 pr-3 text-white/70 whitespace-nowrap">{r.chamber} · {r.voteDate}</td>
                <td className={`py-2 pr-3 text-right font-mono tabular-nums ${r.oldHit ? "text-white/70" : "text-rose-300"}`}>{pct(r.oldProb)}{r.oldModelVersion ? <span className="text-white/30"> v{r.oldModelVersion}</span> : null}</td>
                <td className={`py-2 pr-3 text-right font-mono tabular-nums font-bold ${r.newHit ? "text-emerald-300" : "text-rose-300"}`}>{pct(r.newProb)}<span className="text-white/30 font-normal"> v{r.newModelVersion}</span></td>
                <td className="py-2 pr-3 text-white/60">
                  {r.scheduleUsed?.applies ? `Floor schedule: ${r.scheduleUsed.procedure}` : (r.signals?.length ? r.signals.join(", ") : "none")}
                </td>
                <td className="py-2 text-right whitespace-nowrap">
                  <span className={`whip-pill !py-0.5 !px-2 !text-[9px] ${r.passed ? "!text-emerald-300 !border-emerald-500/40 !bg-emerald-500/10" : "!text-rose-300 !border-rose-500/40 !bg-rose-500/10"}`}>{r.passed ? "Passed" : "Failed"}</span>
                  <span className="ml-1 text-white/40">{r.voiceVote ? "voice" : `${r.actualYes}-${r.actualNo}`}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
